var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v("AI: расходы")]), _vm.loading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "article"
    }
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('v-card', {
    staticClass: "mb-4"
  }, [_c('v-card-title', [_vm._v(" Расход за сегодня "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.fetchBudget();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _vm.budget ? _c('v-card-text', [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" $" + _vm._s(_vm.budget.spentTodayUsd) + " из $" + _vm._s(_vm.budget.dailyLimitUsd) + " ")]), _c('v-progress-linear', {
    attrs: {
      "value": _vm.budget.dailyLimitUsd > 0 ? _vm.budget.spentTodayUsd / _vm.budget.dailyLimitUsd * 100 : 0,
      "height": "14",
      "color": _vm.budget.limitReached ? 'red' : 'green'
    }
  }), _vm.budget.limitReached ? _c('v-alert', {
    staticClass: "mt-3",
    attrs: {
      "type": "warning",
      "dense": ""
    }
  }, [_vm._v(" Дневной лимит расходов на AI достигнут. ")]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }